import { Component, Inject, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { NgbAccordionDirective } from '@ng-bootstrap/ng-bootstrap';
import { AuthMethodViewModel, SoftTokenAuthMethodViewModel } from '../../../../services/identity';
import { LibConfig, LibConfigService } from '../../../enrollment/libconfig.service';
import { MethodBase } from '../base/base.component';

@Component({
  selector: 'app-method-soft-token',
  standalone: false,
  templateUrl: './soft-token.component.html',
  styleUrl: './soft-token.component.scss'
})
export class SoftTokenComponent extends MethodBase {
  private softTokenMethod: SoftTokenAuthMethodViewModel;

  private isThirdParty: boolean;
  private hasAutoEnrolled: boolean;
  private enrolUrl: string;
  private secretPushCode: string;

  private isModalHidden: boolean = true;
  private gettingQr: boolean = false;
  private chosenAuthenticatorType: string = 'securenvoy';
  private configureChoice: string;

  private interval!: number;

  @ViewChild('acc') accordion!: NgbAccordionDirective;

  constructor(
    private fb: FormBuilder,
    @Inject(LibConfigService) private config: LibConfig
  ) {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.softTokenMethod = this.method as SoftTokenAuthMethodViewModel;
    if (this.isSelf) {
      this.setup();
      this.monitorFormStatus();
    } else {
      this.formStatusChanged.emit({ sequence: this.method.sequence, index: 0, status: 'VALID', touched: this.isEditing });
    }
  }

    setup(): void {
      this.form = this.fb.group({
        checkCode: ['', Validators.required],
        tokenUrl: [''],
        pushEnabled: [this.options.state.softToken.pushEnabled]
      });

      if (!this.isEditing) {
        this.form.controls.checkCode.disable();
      }

      if (this.options.state.softToken.pushEnforced && this.options.state.softToken.pushAllowed) {
        this.form.controls['pushEnabled'].disable();
        this.options.state.softToken.authenticatorType = 'securenvoy';
      } else if (!this.options.state.softToken.pushAllowed) {
        this.options.state.softToken.pushEnabled = false;
        this.form.controls['pushEnabled'].disable();
        this.form.controls['pushEnabled'].setValue(false);
      }

      if (this.options.state.softToken.authenticatorType != 'both') {
        this.chosenAuthenticatorType = this.options.state.softToken.authenticatorType;
        this.isThirdParty = this.chosenAuthenticatorType == 'thirdparty';
      }

      if (this.isEditing) {
        this.startEdit();
      }

      this.getUserSeedCode();
    }
    cancel(): void {
        
    }
  getMethod(): AuthMethodViewModel {
    this.softTokenMethod.checkCode = this.form?.value?.checkCode;
    this.softTokenMethod.pushEnabled = this.form?.value?.pushEnabled && this.configureChoice == 'qr' && !this.isThirdParty;
    this.softTokenMethod.tokenUrl = this.form?.value?.tokenUrl;
    return this.softTokenMethod;
  }

  override startEdit(): void {
    this.form.controls.checkCode.enable();
    if (this.options.state.softToken.authenticatorType != 'thirdparty') {
      this.startCheckAutoEnrolTimer();
    }
  }

  override endEdit(): void {
    this.form.controls.checkCode.disable();
    if (this.interval) {
      window.clearInterval(this.interval);
    }
  }

  startCheckAutoEnrolTimer() {
    this.interval = window.setInterval(() => {
      this.checkAutoEnrol();
    }, this.config.pushCheckTime * 1000);
  }

  setAuthenticatorType(type: string) {
    this.chosenAuthenticatorType = type;
    this.isThirdParty = type == 'thirdparty';
    this.getUserSeedCode();
  }

  checkAutoEnrol() {
    this.subscriptions.add(
      this.options.functions.softtoken.userEnrolReadyStatus(!this.options.state.softToken.pushEnabled).subscribe(
        (data: any) => {
          if (data === true) {
            window.clearInterval(this.interval);
            this.hasAutoEnrolled = true;
            this.form.controls.checkCode.setValue('AUTOENROLLED');
            this.enrolUrl = '';
            this.accordion?.collapseAll();
            this.closeQrImage();
            const element = document.getElementById('target');
            if (element) {
              this.scroll(element);
            }
            var overlay = document.getElementById('overlay');
            if (overlay) { overlay.style.display = 'block'; }
          }
        }));
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView();
  }

  removeOverlay() {
    let overlay = document.getElementById('overlay')
    if (overlay) { overlay.style.display = 'none'; }
  }

  enlargeImage() {
    if (!this.gettingQr) {
      this.isModalHidden = false;
    }
  }

  closeQrImage() {
    this.isModalHidden = true;
  }

  changePushEnabled() {
    this.options.state.softToken.pushEnabled = !this.options.state.softToken.pushEnabled;
    this.getUserSeedCode();
  }

  getUserSeedCode() {
    this.gettingQr = true;
    this.subscriptions.add(
      this.options.functions.softtoken.userSeedUrl(!this.form.value.pushEnabled, this.chosenAuthenticatorType == 'thirdparty').subscribe(
        (data: any) => {
          this.enrolUrl = data.link;
          this.form.controls.tokenUrl.setValue(this.enrolUrl, {emitEvent: false});
          const response1 = this.enrolUrl.split('?');
          const response2 = response1[1].split('&');
          const response3 = response2[0].split('=');
          this.secretPushCode = response3[1];
          const regAddSpaceCharacterInput = this.secretPushCode.length > 13 ? this.options.validators.softtoken.regAddSpaceCharacterInputThirdParty : this.options.validators.softtoken.regAddSpaceCharacterInput
          this.secretPushCode = this.secretPushCode.replace(regAddSpaceCharacterInput, this.options.validators.softtoken.regAddSpaceCharacterOutput);
          this.gettingQr = false;
        }));
  }

  chooseConfigureMethod(choice: string) {
    this.configureChoice = choice;
  }

}
